import { sortFilterSerializer } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

export interface TradeItemListSortFilter {
  field: "gtin" | "name";
  order?: "DESC" | "ASC";
}

export interface TradeItemListQueryFilters {
  limit?: number;
  offset?: number;
  searchText?: string;
  sortBy?: TradeItemListSortFilter[];
}

export const tradeItemListQueryFiltersSerializer = MSerializers.object<TradeItemListQueryFilters>({
  limit: MSerializers.integer.optional(),
  offset: MSerializers.integer.optional(),
  searchText: MSerializers.string.optional(),
  sortBy: sortFilterSerializer("gtin", "name").optional(),
});
